import { useResultsSelector } from "@app/modules/results/hooks/use-results-selector";
import { getSegmentsWithSeatSelectionByTripId } from "@app/modules/results/selectors/trips/get-segments-with-seat-selection-by-trip-id";

export const useSegmentsIdWithSeatSelection = (trip_id: string | undefined) => {
  const segments_id_with_seat_selection = useResultsSelector(state => {
    if (!trip_id) {
      return [];
    }

    return getSegmentsWithSeatSelectionByTripId(state, trip_id);
  });

  return {
    segments_id_with_seat_selection
  };
};
